module.exports = __webpack_public_path__ + "static/media/YM19_1.a941dc73.jpg";